export const app = (state) => state.app;

export const getModalClosedState = (state) => app(state).modalWasClosed;

export const getOneOffModalClosedState = (state) =>
  app(state).oneOffModalClosed || {};

export const tracking = (state) => state.tracking;

export const getRouter = (state) => state.router;

export const getSupportState = (state) => state.support;

export const getShopState = (state) => state.shop;

export const getCheckoutState = (state) => getShopState(state).checkout;

export const getCheckoutId = (state) => getShopState(state).checkout.id;

export const getCartLineItems = (state) =>
  getShopState(state).checkout.lineItems;

export const getCheckoutCustomAttributes = (state) =>
  getShopState(state).checkout.customAttributes;

export const getOrderedLineItems = (state) =>
  getShopState(state).orderedLineItems;

export const getAllProducts = (state) => getShopState(state).allProducts;

export const getProductData = (state, productKey) =>
  getShopState(state).allProducts[productKey];

export const getGiftWithPurchaseProducts = (state) =>
  getShopState(state).giftWithPurchaseProducts;

export const getSupportCategories = (state) =>
  getSupportState(state).categories;

export const getSupportCategoriesIsFetchingState = (state) =>
  getSupportCategories(state).isFetching;

export const getSupportCategory = (state, categoryid) =>
  getSupportCategories(state)[categoryid];

export const getSupportSections = (state) => getSupportState(state).sections;

export const getSupportSectionsIsFetchingState = (state) =>
  getSupportSections(state).isFetching;

export const getSupportSectionsForCategory = (state, categoryId) =>
  getSupportSections(state).byCategory[categoryId] || [];

export const getSupportSectionDetail = (state) =>
  getSupportState(state).section;

export const getSupportSectionDetaillsFetchingState = (state) =>
  getSupportSectionDetail(state).isFetching;

export const getSupportArticles = (state) => getSupportState(state).articles;

export const getSupportArticlesIsFetchingState = (state) =>
  getSupportArticles(state).isFetching;

export const getSupportArticlesForSection = (state, sectionId) =>
  getSupportArticles(state).bySection[sectionId] || [];

export const getSupportArticleDetail = (state) =>
  getSupportState(state).article;

export const getSupportArticleDetaillsFetchingState = (state) =>
  getSupportArticleDetail(state).isFetching;

export const getSupportSearch = (state) => getSupportState(state).search;

export const getSupportSearchQuery = (state) => getSupportSearch(state).query;

export const getSupportPreviousSearchQuery = (state) =>
  getSupportSearch(state).previousQuery;

export const getSupportSearchIsFetchingState = (state) =>
  getSupportSearch(state).isFetching;

export const getSupportSearchResultsData = (state) =>
  getSupportSearch(state).data;

export const getSearchResultsPageCountPages = (state) =>
  getSupportSearch(state).data.page_count;

export const getCollections = (state) => getShopState(state).collections;

export const getHatchCollection = (state) =>
  getCollections(state).hatchCollection;

export const getHatchCollectionProducts = (state) =>
  getHatchCollection(state).products;

export const getHatchCollectionFetchingState = (state) =>
  getHatchCollection(state).isFetching;

export const getAdultsCollection = (state) =>
  getCollections(state).hatchCollection;

export const getAdultsCollectionProducts = (state) =>
  getAdultsCollection(state).products;

export const getAdultsCollectionFetchingState = (state) =>
  getAdultsCollection(state).isFetching;

export const getSleepCollection = (state) =>
  getCollections(state).sleepCollection;

export const getSleepCollectionProducts = (state) =>
  getSleepCollection(state).products;

export const getSleepCollectionFetchingState = (state) =>
  getSleepCollection(state).isFetching;

export const getSleepGoalSubCollections = (state) =>
  getSleepCollection(state).subCollections;

export const getSupportAllDataIsFetching = (state) =>
  getSupportCategoriesIsFetchingState(state) ||
  getSupportSectionsIsFetchingState(state) ||
  getSupportArticlesIsFetchingState(state);

const reduxSelectors = {
  app,
  getModalClosedState,
  getOneOffModalClosedState,
  tracking,
  getRouter,
  getSupportState,
  getSupportCategories,
  getSupportCategoriesIsFetchingState,
  getSupportCategory,
  getSupportSections,
  getSupportSectionsIsFetchingState,
  getSupportSectionsForCategory,
  getSupportSectionDetail,
  getSupportSectionDetaillsFetchingState,
  getSupportArticles,
  getSupportArticlesForSection,
  getSupportArticleDetail,
  getSupportArticleDetaillsFetchingState,
  getShopState,
  getCheckoutState,
  getCheckoutId,
  getOrderedLineItems,
  getCheckoutCustomAttributes,
  getAllProducts,
  getProductData,
  getGiftWithPurchaseProducts,
  getSupportSearch,
  getSupportSearchQuery,
  getSupportPreviousSearchQuery,
  getSupportSearchIsFetchingState,
  getSupportSearchResultsData,
  getSearchResultsPageCountPages,
  getCollections,
  getHatchCollection,
  getHatchCollectionProducts,
  getHatchCollectionFetchingState,
  getSleepCollection,
  getSleepCollectionProducts,
  getSleepCollectionFetchingState,
  getSleepGoalSubCollections,
  getSupportAllDataIsFetching,
};

export default reduxSelectors;
